<template>
  <!-- 后台管理系统主界面 -->
  <div class="wrapper" :class="isdate ? 'data' : ''">
    <el-container>
      <el-header>
        <!-- 头 -->
        <!-- 判断在移动端上-->
        <div v-if="screenWidth <= 768" style="text-align: left">
          <el-button icon="el-icon-s-unfold" @click="show()"></el-button>
        </div>
        <div
          style="position: absolute; padding-left: 20px"
          v-if="screenWidth > 768"
        >
          <img
            @click="handleClickImg"
            style="
              width: 50px;
              height: 50px;
              margin-top: 6px;
              vertical-align: middle;
            "
            src="../images/mengzhengfile.png"
            alt="系统logo"
          />
          <span style="color: #fff">暖心课堂后台管理系统</span>
        </div>

        <div class="hd-city" style="width: 200px; position: absolute;  right: 250px; color: #fff; " >
          城市：{{ this.cityvalue === '1' ? '北京' : this.cityvalue==='2' ?'深圳': this.cityvalue === '3' ? '上海' : this.cityvalue === '1,2' ? '北京、深圳' : this.cityvalue === '1,3' ? '北京、上海' : this.cityvalue === '2,3' ? '深圳、上海' : this.cityvalue === '1,2,3' ?  '北京、深圳、上海' : '暂无权限' }}
          <!-- <el-select v-model="cityvalue" placeholder="请选择" style="width: 100px;">
            <el-option
              v-for="item in optionsListt"
              :key="item.id"
              :label="item.dictValue"
              :value="item.dictType">
            </el-option>
          </el-select> -->
        </div>

        <div class="hd-chat" style=" text-align: right;  position: absolute;  right: 90px;  padding-left: 10px;  display: flex;  top: 15px;   color: #fff;  font-size: 35px;  width: 150px;" @click="handleClickTop">
            <i class="el-icon-chat-dot-round"></i>
            <div class="hd-chat-badge" style="
              background: #e41b1b;
              height: 20px;
              width: 20px;
              border-radius: 50%;position: absolute;  right: 111px; display: flex;">
              <span style="position: absolute;  right: 5px; display: flex; top: -20px; font-weight: 900; color: #fff" :style="{ fontSize: messageNmu >= 10 ? '9px' : '15px',  }"> {{ messageNmu ? messageNmu : 0 }}</span>
            </div>
        </div>

        <div style="text-align: end;">
          <!-- 系统标题 -->
          <!-- <img
            :src="initName"
            style="width: 30px; height: 30px; vertical-align: middle"
            alt="默认用户头像"
          /> -->
          <el-dropdown @command="handleCommand">
            <div class="hd-user-inner" style="
              text-align: right;
              background: #bfefff;
              right: 18px;
              padding-left: 10px;
              display: flex;
              width: 166px;
            ">
          <viewer :images="photo">
            <img  style="position: absolute; margin-top: 15px; width: 30px; height: 30px;" v-for="(src, index) in photo" :src="src"  :key="index"  />
          </viewer>

          <span style="font-size: 14px;margin-left: 36px;">您好，{{ name }}</span>
          <!-- <el-dropdown @command="handleCommand"> -->
            <i class="el-icon-caret-bottom" style="margin-right: 15px"></i>
            <el-dropdown-menu slot="dropdown">
              <!-- <el-dropdown-item command="center">个人中心</el-dropdown-item> -->
              <!-- <el-dropdown-item command="updatePassword"
                >修改密码</el-dropdown-item
              > -->
              <el-dropdown-item command="exit" style="width: 110px"
                >退出</el-dropdown-item
              >
            </el-dropdown-menu>
          </div>
          </el-dropdown>
        </div>
      </el-header>
      <el-container>
        <div v-if="screenWidth <= 768 && show_nav" class="nav-backdrop" @click="show_nav = false"></div>
        <el-aside class="nav-aside" width="250px" style="height: 90vh; overflow-y: scroll;" v-if="show_nav"  :class="showclass">

          <left-menu @handleClickRouter="handleClickRouter" />

          <!-- 侧边 -->
          <!-- <left-menu @handleLeftMenu="handleLeftMenu" :menuList="menuList" /> -->
          <!-- 默认展开的索引default-active -->
          <!-- <el-menu
            :default-active="default_active"
            @select="handleSelect"
            unique-opened
          >
            <el-submenu
          v-for="menu in menuList"
              :index="menu.jurId"
              :key="menu.jurId"
            >
              <template slot="title">
                <router-link :to="menu.jurUrl" class="links">
                  <i :class="menu.jurIcon"></i>{{ menu.jurTitle }}
                </router-link>
              </template>
            </el-submenu>  -->

          <!-- <el-submenu v-for="menu in menuList" index="1">
              <template slot="title">
                <i class="el-icon-location"></i>
                <span>{{ menu.jurTitle }}</span>
              </template>
              <el-menu-item-group v-for="aa in menu.children">
                <template slot="title">{{ aa.jurTitle }}</template>

              </el-menu-item-group>
            </el-submenu> -->

          <!-- <el-menu-item index="0">
              <template slot="title">
                <router-link to="/systemdata" class="links">
                  <i class="el-icon-setting"></i>系统数据
                </router-link>
              </template>
            </el-menu-item>
            <el-submenu index="1">
              <template slot="title">
                <i class="el-icon-s-custom"></i>客资管理
              </template>
              <el-menu-item index="1-1">
                <router-link to="/customermange" class="links"
                  >查看客资</router-link
                >
              </el-menu-item>
              <el-menu-item index="1-2">
                <router-link to="/customercollect" class="links"
                  >添加客资</router-link
                >
              </el-menu-item>
            </el-submenu>
            <el-submenu index="2" >
              <template slot="title">
                <i class="el-icon-s-data"></i>排课管理
              </template>
              <el-menu-item index="2-1">
                <router-link to="/classtasklist" class="links"
                  >课表排班</router-link
                >
              </el-menu-item>
              <el-menu-item index="2-2">
                <router-link to="/coursetable" class="links"
                  >查看课表</router-link
                >
              </el-menu-item>
            </el-submenu>

            <el-submenu index="3" >
              <template slot="title">
                <i class="el-icon-reading"></i>课程管理
              </template>
              <el-menu-item index="3-1">
                <router-link to="/onlinecourse" class="links"
                  >网课列表</router-link
                >
              </el-menu-item>
              <el-menu-item index="3-2">
                <router-link to="/onlinecategory" class="links"
                  >网课类别</router-link
                >
              </el-menu-item>
            </el-submenu>

            <el-submenu index="4">
              <template slot="title">
                <i class="el-icon-user"></i>讲师管理
              </template>
              <el-menu-item-group>
                <el-menu-item index="4-1">
                  <router-link to="/teacherlist" class="links"
                    >所有讲师</router-link
                  >
                </el-menu-item>
              </el-menu-item-group>
            </el-submenu>

            <el-submenu index="5">
              <template slot="title">
                <i class="el-icon-box"></i>班级管理
              </template>
              <el-menu-item-group>
                <el-menu-item index="5-1">
                  <router-link to="/classmanager" class="links"
                    >所有班级</router-link
                  >
                </el-menu-item>
              </el-menu-item-group>
            </el-submenu>

            <el-submenu index="6" >
              <template slot="title">
                <i class="el-icon-user"></i>学生管理
              </template>
              <el-menu-item-group>
                <el-menu-item index="6-1">
                  <router-link to="/studentlist" class="links"
                    >所有学生</router-link
                  >
                </el-menu-item>
              </el-menu-item-group>
            </el-submenu>

            <el-submenu index="7" >
              <template slot="title">
                <i class="el-icon-notebook-1"></i>教学资料
              </template>
              <el-menu-item index="7-1">
                <router-link class="links" to="/studydocs"
                  >学习文档</router-link
                >
              </el-menu-item>
              <el-menu-item index="7-2">
                <router-link class="links" to="/exercise">在线测试</router-link>
              </el-menu-item>
              <el-menu-item index="7-3">
                <router-link to="/courseinfolist" class="links"
                  >教材列表</router-link
                >
              </el-menu-item>
            </el-submenu>

            <el-submenu index="8" >
              <template slot="title">
                <i class="el-icon-office-building"></i>教学设施
              </template>
              <el-menu-item index="8-1">
                <router-link class="links" to="/teachbuildinglist"
                  >教学楼管理</router-link
                >
              </el-menu-item>
              <el-menu-item index="8-2">
                <router-link to="/classroomlist" class="links"
                  >教室列表</router-link
                >
              </el-menu-item>
              <el-menu-item index="8-3">
                <router-link to="/setteacharea" class="links"
                  >教学区域安排</router-link
                >
              </el-menu-item>
            </el-submenu>
            <el-submenu index="9">
              <template slot="title">
                <i class="el-icon-s-tools"></i>系统管理
              </template>
              <el-menu-item index="9-1">
                <router-link to="/usermanagement" class="links" >用户管理</router-link>
              </el-menu-item>
              <el-menu-item index="9-2">
                <router-link to="/rolemanagement" class="links" >角色管理</router-link>
              </el-menu-item>
              <el-menu-item index="9-3">
                <router-link to="/authmanagement" class="links" >权限管理</router-link>
              </el-menu-item>
            </el-submenu>
            <el-submenu index="10" >
              <template slot="title">
                <i class="el-icon-help"></i>帮助中心
              </template>
              <el-menu-item index="10-1">
                <router-link to="/help" class="links">使用说明</router-link>
              </el-menu-item>
            </el-submenu> -->
          <!-- </el-menu> -->
        </el-aside>

        <el-main style="height: 90%;">
          <el-breadcrumb
            separator-class="el-icon-arrow-right"
            style="background: #fffdfd; padding-bottom: 20px; padding-top: 10px">
            <el-breadcrumb-item v-for="(itme,index) in itmeBreadList" :key="index">
              {{ itme.jurTitle }}
            </el-breadcrumb-item>
          </el-breadcrumb>
          <!-- Main区域，数据显示 -->
          <router-view></router-view>
        </el-main>
      </el-container>
      <!-- 显示系统时间 -->
      <!-- <el-footer style="color: #fff">{{ time }}</el-footer> -->
    </el-container>





    <message v-if="showComponents" @handleEventBts="handleEventBts" :records="records" @handleEvent="handleEvent"></message>



  </div>
</template>

<script>
// import LeftMenu from './menu.vue'
import LeftMenu from "../manager/layout/menu.vue";
import { isDate } from '../utils/date'
import axios from "axios";
import apiBaseUrl from "../../config/api";
import message from "../newsMessage-components/message.vue";

export default {
  name: "ManagerMain",
  components: {
    LeftMenu,
    message
  },
  data() {
    return {
      records:[],
      messageNmu: 0,
      showComponents:false,
      photo:[],
      initName:'',
      isdate:'',
      showclass: 'asideshow',
      itmeBreadList: [
        { jurTitle: "客资管理"},
        { jurTitle: "查看客资"},
      ],
      itmeBread: { item: {} },
      // flag: false, //隐藏标志
      show_nav: true, //1
      time: "",
      screenWidth: document.documentElement.clientWidth, //1
      default_active: "0",
      name: "",
      menuList: JSON.parse(window.localStorage.getItem("jur")),
      // optionsListt:[
      //   {dictValue:"北京", dictType:1 },
      //   {dictValue:"深圳", dictType:2 },
      // ],
      cityvalue:'',
    };
  },
  // computed: {
  //   // isTeacher: () => {
  //   //   return window.localStorage.getItem("teacher") != null;
  //   // }

  // },
  // created() {
  //   const jur = JSON.parse(window.localStorage.getItem("jur"));
  //   if (Array.isArray(jur) && jur.every(item => item.hasOwnProperty('jurId') && item.hasOwnProperty('jurUrl') && item.hasOwnProperty('jurIcon'))) {
  //     this.menuList = jur;
  //     
  //     // 设置defaultActive为menuList中的第一个jurId
  //     this.defaultActive = this.menuList[0].jurId;
  //   } else {
  //     console.error('数据格式错误！');
  //   }
  // },
  // created(){
  //   this.$router.push('/customermange')
  // },
  created() {
    this.menuList = JSON.parse(window.localStorage.getItem("jur"));
    

    setTimeout(() => {
      this.cityvalue = window.localStorage.getItem('cityTepy')
    
    },1000)
    
    // 
    // const defaultHref = this.menuList[0].children
    //   ? this.defaultActive(this.menuList[0].children)
    //   : this.menuList[0];
    //   if (this.$route.path !== defaultHref.jurUrl) {
    //   this.$router.replace({
    //     path: defaultHref.jurUrl
    //   });
    // }

   
  },
  mounted() {
   

    axios.post(`${apiBaseUrl}/information/findList`, { pageNum:1, pageSize: 100000 },{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then(res => {
          if (res.data.code == 200) {
              this.messageNmu = res.data.data.total ? res.data.data.total : 0
              if(res.data.data.records.length > 0){
                this.records = res.data.data.records
              }else{
                this.records = []
              }
          } else {
              // this.$message({  message: res.data.message,   type: "error"})
          }
        }).catch(err => {
          //  this.$message({  message: err,   type: "error"})
    })

    this.handleMessges()

    this.isdate =  isDate()

    // 
    //1
    window.addEventListener("resize", this.updateScreenWidth);

    setInterval(() => {
      this.getTime();
    }, 1000);

    let admin = window.localStorage.getItem("admin");


    // 
    if (admin != null) {
        this.name = JSON.parse(admin).realname;
        this.initName = (this.name === '卷柏' || this.name === '顾词') ? 'http://mz-app-develop.oss-cn-beijing.aliyuncs.com/mz_pc/guci.jpg' : this.name ==='李开心' ? 'https://img2.woyaogexing.com/2021/08/30/bfe0743d022246449bceabdbdcbb609f%21400x400.jpeg' : 'http://mz-app-develop.oss-cn-beijing.aliyuncs.com/mz_pc/default.png'
        this.photo = [this.initName]
    } else {
        let teacher = window.localStorage.getItem("teacher");
        if (teacher != null) {
          this.name = JSON.parse(teacher).realname;
        }
    }
    if (this.screenWidth <= 768) {
        this.show_nav = false;
    } else {
        this.show_nav = true;
    }
  },

  //1
  beforeDestroy() {
    window.removeEventListener("resize", this.updateScreenWidth);
  },
  watch: {
    // 手机端点击菜单跳转后自动收起抽屉
    $route() {
      if (this.screenWidth <= 768 && this.show_nav) {
        this.show_nav = false;
      }
    },
  },
  methods: {

    handleEvent(e){
      this.messageNmu = e
    },

    handleMessges(){
    setInterval(()=>{
        axios.post(`${apiBaseUrl}/information/findList`, { pageNum:1, pageSize: 100000 },{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then(res => {
          if (res.data.code == 200) {
              this.messageNmu = res.data.data.total ? res.data.data.total : 0
              if(res.data.data.records.length > 0){
                this.records = res.data.data.records
              }else{
                this.records = []
              }
          } else {
              // this.$message({  message: res.data.message,   type: "error"})
          }
        }).catch(err => {
          //  this.$message({  message: err,   type: "error"})
        })
    },10000)
    },

    handleClickTop(){
      this.showComponents = true
    },
    handleEventBts(){
      this.showComponents = false
    },

    handleClickImg(){
      this.$router.push("/model");
    },
    handleClickRouter(a,b,c){
      this.itmeBreadList = []
      let P = { jurTitle: a }
      let C = { jurTitle: b }
      this.itmeBreadList.push(P)
      this.itmeBreadList.push(C)
    },
    handleLeftMenu(item) {
      if (item) {
        
        this.itmeBread = item;
      }
      if (item.item.jurUrl) {
        this.$router.push({
          path: item.item.jurUrl,
          query: {
            activeName: item.item.activeName,
            names: item.item.names,
            type: item.item.type,
          },
        });
        /*兄弟页面可通过触发,bus方法需要另外安装依赖
                this.$bus.$on('changeLeftMenu', item => {
                this.activeName = item.activeName
                this.names = item.names
                this.updateVal()//接口
            })
                */
        //  
        this.$emit("changeLeftMenu", item);
      }
    },
    // defaultActive(list) {
    //   if (list[0].children) {
    //     return this.defaultActive(list[0].children);
    //   } else {
    //     return list[0];
    //   }
    // },
    generateMenuItems(h, menuItems) {
      
      return menuItems.map((item) => {
        if (item.children != null && item.children.length > 0) {
          

          return h("el-submenu", { attrs: { index: item.jurId } }, [
            h("template", { slot: "title" }, [
              h("i", { class: item.jurIcon }),
              item.jurTitle,
            ]),
            // this.generateMenuItems(h, item.children)
          ]);
        } else {
          
          // return h('el-menu-item', { attrs: { index: String(item.jurId) } }, [
          //   h('router-link', { attrs: { to: item.jurUrl }, class: 'links' }, [
          //     h('i', { class: item.jurIcon }),
          //     item.jurTitle
          //   ])
          // ]);
        }
      });
    },
    //1
    updateScreenWidth() {
      const w = document.documentElement.clientWidth;
      const wasMobile = this.screenWidth <= 768;
      this.screenWidth = w;
      // 仅在跨越 768 断点时重置侧栏,避免手机端地址栏伸缩/软键盘等 resize 事件误关抽屉
      if (w <= 768 && !wasMobile) {
        this.show_nav = false;
      } else if (w > 768 && wasMobile) {
        this.show_nav = true;
      }
    },
    // 下拉菜单功能，退出、个人中心
    handleCommand(command) {
      // alert(command)
      if (command == "exit") {
        sessionStorage.removeItem("tokenInfo");
        localStorage.removeItem("token");
        localStorage.removeItem("admin");
        localStorage.removeItem("teacher");
        localStorage.removeItem("cityTepy");
        // 判断，返回指定页面
        this.$router.push("/");
      } else if (command == "center") {
        // 跳转到个人中心
      } else if (command == "updatePassword") {
        // 修改密码页面
        this.$router.push("/updatepass");
      }
    },
    //1
    show() {
      if (this.show_nav) {
        this.show_nav = false;
      } else {
        this.show_nav = true;
      }
    },

    // 获取系统时间
    getTime() {
      this.time = new Date().toLocaleString();
    },

    // 展开一个菜单
    handleSelect(val) {
      this.default_active = val;
    },
  },
};
</script>

<style lang="less" scoped>
.wrapper {
  height: 100%;
  width: 100%;

  .a {
    text-decoration: none !important;
    color: #303133 !important;
  }

  .links {
    text-decoration: none !important;
    color: #303133 !important;
  }
}

.el-container {
  height: 100%;
  padding: 0;
  margin: 0;
  width: 100%;
}

.el-header,
.el-footer {
  // background-color: #b3c0d1;
  background-color: #438eb9;
  color: #333;
  text-align: center;
  line-height: 60px;
}

.el-aside {
  position: sticky;
  top: 0;
  z-index: 999;
  // background-color: #d3dce6;
  color: #333;
  text-align: center;
  line-height: 200px;
  overflow: hidden;
}

.el-icon-caret-bottom{
  padding-left: 15px;
  padding-top: 22px;
}

.el-main {
  background-color: #fff;
  color: #333;
  text-align: center;
  padding: 10px;
  overflow: auto;
}

body > .el-container {
  margin-bottom: 40px;
}

.el-container:nth-child(5) .el-aside,
.el-container:nth-child(6) .el-aside {
  line-height: 260px;
}

.el-container:nth-child(7) .el-aside {
  line-height: 320px;
}

// .el-header{
//   display: flex;
//   justify-content: space-between;
// }
@media screen and (max-width: 768px) {
  .el-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 8px;
    line-height: 1.2;
  }
  /* 头部元素重排:隐藏城市,消息图标紧凑,用户区收窄 */
  .hd-city {
    display: none !important;
  }
  .hd-chat {
    right: 148px !important;
    width: 40px !important;
    padding-left: 0 !important;
    font-size: 24px !important;
    top: 18px !important;
    justify-content: center;
  }
  .hd-chat-badge {
    right: -6px !important;
    top: -4px !important;
  }
  .hd-user-inner {
    width: auto !important;
    max-width: 128px;
    padding-left: 6px !important;
    overflow: hidden;
    white-space: nowrap;
  }
  /* 侧栏变为覆盖式抽屉 */
  .nav-aside {
    position: fixed !important;
    left: 0;
    top: 60px;
    bottom: 0;
    height: calc(100vh - 60px) !important;
    z-index: 2000;
    background: #fff;
    box-shadow: 2px 0 12px rgba(0, 0, 0, 0.35);
  }
  .nav-backdrop {
    position: fixed;
    left: 0;
    top: 60px;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.45);
    z-index: 1999;
  }
  .el-main {
    padding: 6px !important;
  }
}

.data{
  pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// src/manager/ManagerMain.vue